module.exports = __webpack_public_path__ + "static/media/sf_700.0d452ba3a190b4f453f01e38c534eadf.png";